import { create } from 'zustand';

/**
 * SSE 通知类型
 */
export interface IReferencesReadyNotice {
    type: 'referencesReady';
    sessionId: string;
    messageId: string;
    referencesCount: number;
}

export type SSENotice = IReferencesReadyNotice;

/**
 * SSE 通知 Store
 * 用于 SSE 处理与 UI 组件之间的解耦通信
 */
interface ISSENoticeStoreState {
    // 当前通知
    notice: SSENotice | null;
    // 发送引用文献准备就绪通知
    referencesReadyNotice: (sessionId: string, messageId: string, referencesCount: number) => void;
    // 清除通知（消费后清除）
    clearNotice: () => void;
}

export const useSSENoticeStore = create<ISSENoticeStoreState>((set) => ({
    notice: null,
    
    referencesReadyNotice: (sessionId, messageId, referencesCount) => set({ 
        notice: {
            type: 'referencesReady',
            sessionId,
            messageId,
            referencesCount,
        }
    }),
    
    clearNotice: () => set({ notice: null }),
}));